export const categories = [
  { id: "works", description: "Travaux (construction)", type: "outcome" },
  {
    id: "taxes",
    description: "Impôt et taxes (ex: TVA, société, cotisation, dgfip)",
    type: "outcome",
  },
  {
    id: "subscribtions",
    description: "Logiciels ou tout abonnement récurrent",
    type: "outcome",
  },
  {
    id: "operational",
    description:
      "Charges opérationnelles (ex: énergie, logiciels, marketing, administratif, loyers)",
    type: "outcome",
  },
  { id: "bank_fees", description: "Frais bancaires (ex: agios)", type: "outcome" },
  { id: "cash_withdrawal", description: "Retrait en espèce", type: "outcome" },
  { id: "restaurant", description: "Restaurant", type: "outcome" },
  { id: "transport", description: "Transport", type: "outcome" },
  { id: "leisure", description: "Loisirs", type: "outcome" },
  { id: "salaries", description: "Salaires (ex: charges sociales, urssaf)", type: "outcome" },
  { id: "loans", description: "Emprunts, intérêts", type: "outcome" },
  { id: "revenues", description: "Revenus (montant positif uniquement)", type: "income" },
  {
    id: "financing",
    type: "income",
    description:
      "Financement (ex: prêt, emprunt, crédit). Montant positif uniquement, en général >1000€",
  },
  {
    id: "intragroup",
    description: "Flux intragroupe (virement interne, cc, trésorerie, apport)",
    type: "outcome and income",
  },
  { id: "other", description: "Autres", type: "outcome and income" },
] as const;

export type CategoryId = (typeof categories)[number]["id"];
export const isCategoryId = (id: string): id is CategoryId => categories.some((c) => c.id === id);
